import React from "react";
import ExcavationMain from "./ExcavationMain";

const AddExcavation = () => {
  return <ExcavationMain />;
};

export default AddExcavation;
